import ky from "ky";

const api = ky.create({ prefixUrl: "https://game.lombard888.ru/api" });
const token =
  "P8h64QgdMSZsIKcOZa6iGedjziKTXoD1uCzwzZRF5ueRemfjyJavPcKzk5xyP8Fa";
export const auth = (email: string): Promise<{ uid: number }> => {
  const body = new FormData();
  body.append("token", token);
  body.append("email", email);
  return api.post("auth_stage1.php", { body }).json();
};
export const verify = (
  code: string,
  uid: number
): Promise<{ res: "Успешная авторизация" }> => {
  const body = new FormData();
  body.append("token", token);
  body.append("code", code);
  body.append("uid", String(uid));
  return api.post("auth_stage2.php", { body }).json();
};
export const getPrize = (
  uid: number
): Promise<{ priz_num: string; code: string }> => {
  const body = new FormData();
  body.append("token", token);
  body.append("uid", String(uid));
  return api.post("get_code.php", { body }).json();
};
